import styled from '@emotion/styled';

export const StyledChartHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .total {
    font-size: 14px;

    & > span:first-of-type {
      margin-right: 6px;
    }
  }
`;

export const StyledChartWrapper = styled.div`
  position: relative;
  margin-top: 10px;
  border: 1px solid #e0e0e0;
`;

export const StyledChartTitle = styled.div`
  display: flex;
  align-items: center;

  .tooltip {
    margin-left: 10px;
    position: relative;
    display: inline-flex;

    &:hover {
      .tooltip-wrapper {
        display: block;
      }
    }

    .tooltip-wrapper {
      position: absolute;
      display: none;
      right: -40px;
      top: 100%;
      padding-top: 10px;
      z-index: 99;

      &:after {
        content: '';
        position: absolute;
        top: 4px;
        right: 42px;
        width: 16px;
        height: 16px;
        transform: rotate(45deg);
        border-radius: 4px;
        background-color: black;
      }
    }

    .tooltip-content {
      width: 300px;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border-radius: 12px;
      background-color: black;
      color: white;
      font-size: 14px;
      white-space: nowrap;
    }
  }
`;

export const StyledPageArrow = styled.button`
  position: absolute;
  top: calc(50% - 48px);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: rgba(185, 185, 185, 0.5);
  z-index: 99;

  &.left {
    left: -24px;
  }

  &.right {
    right: -24px;
    transform: rotateZ(180deg);
  }

  &:after,
  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 14px;
    height: 3px;
    background-color: white;
  }

  &:after {
    transform: translateX(-50%) translateY(calc(-50% + 4px)) rotateZ(45deg);
  }

  &:before {
    transform: translateX(-50%) translateY(calc(-50% - 4px)) rotateZ(-45deg);
  }
`;
